import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography, Backdrop } from '@mui/material';
import apiService from 'Network/apiService';

const TokenRefreshLoader = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    // Set the loading callback for token refresh
    apiService.setRefreshLoadingCallback(setIsRefreshing);

    // Safety timeout to hide loading if it gets stuck
    const timeout = setTimeout(() => {
      setIsRefreshing(false);
    }, 10000); // 10 seconds timeout

    return () => clearTimeout(timeout);
  }, []);

  if (!isRefreshing) return null;

  return (
    <Backdrop
      open={isRefreshing}
      sx={{
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          backgroundColor: 'white',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="h6" color="primary">
          Refreshing access token...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please wait while we refresh your session
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default TokenRefreshLoader;
